const isLearnerView = (document.location.href.indexOf('learner') > -1);
const isLocalHost = document.location.href.indexOf('localhost') > -1 && !isLearnerView;                         // our AWS ec2 instance url
const isAllenEnvironment =
    document.location.href.indexOf('alleni.com') > -1 ||
    document.location.href.indexOf('novastaging.ddns.net') > -1 ||
    document.location.href.indexOf('ec2-18-212-26-13') > -1
    && !isLearnerView;

// set to true if we want to load data from sheets API
// const USE_SHEETS_DATA = true;
// NOVA Story 1
// const SHEET_ID = '1M5HEfjTSHR3ho5Nc7PyKWEE988FOTpnvnhfC2t5WurI';

// NOVA Templates
// const SHEET_ID = '1Qya-zodL5ouZNcoxjr7ZHJzGjdcSYHE9am0lWLhE6Ls';

// Sheet for external help
const SHEET_ID = '1EnCECzXSgwwk7K_gMbzwkXRR277kPxoG47nd7NQdjAQ';
const USE_SHEETS_DATA = process.env.REACT_APP_USE_SHEETS_DATA === 'true' || false ;
console.log('USE_SHEETS_DATA', USE_SHEETS_DATA, 'proc', process);
const initialLocation = {
    module:0,
    lesson:0,
    chapter:0,
    segment:0,
}

const devInitialLocation = {
    // module:0,
    // lesson:0,
    // chapter:0,
    // segment:1,
    module: USE_SHEETS_DATA ? 0 : 0,    // use the second one to avoid sheet data not loading when you're testing something in an example module
    lesson:0,
    chapter:0,
    segment:0
}

const parseInitialLocation = () => {
    const query = window.location.search.substring(1);
    const URLVars = query.split('&');
    const locationObject = isLocalHost ? devInitialLocation : initialLocation;
    URLVars.forEach(param => {
        let pair = param.split('=');
        const key = decodeURIComponent(pair[0]);
        const val = Number(decodeURIComponent(pair[1]));

        if(
            key === 'module' ||
            key === 'lesson' ||
            key === 'chapter' ||
            key === 'segment'
        ){
            locationObject[key] = val;
        }
    })
    return locationObject;
}

const config = {
    //jiraTag does NOT include script tags, just the url

    jiraTag:"https://alleninteractions.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/r5gghz/b/3/bc54840da492f9ca037209037ef0522a/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=56f15f5f",
    // repo url should be repo-id/src/
    repoURL:"allen-react-boilerplate/src/",
    isAllenEnvironment:isAllenEnvironment,
    isLocalHost:isLocalHost,
    scorm:{
        version:"scorm2004",
        isScored:false
    },
    initialLocation: parseInitialLocation(),
    USE_SHEETS_DATA: USE_SHEETS_DATA,
    SHEET_ID: SHEET_ID
}

export default config

